import gql from 'graphql-tag'
import store from '../index'
import moment from 'moment'
import { properCase } from '../../util/string'

export const init = async ({ commit, dispatch }) => {
  try {
    commit('setLoaded', false)    
    await dispatch('auth/waitUntilLoaded', null, { root: true })
    // await dispatch('fetchAccountCarts')
    await dispatch('fetchActiveCart', 'stock')
    await dispatch('fetchActiveCart', 'container')
    await dispatch('fetchActiveCart', 'retail')
    commit('setLoaded', true)
  } catch (error) {
    console.log(error)
  }
}

export const waitUntilLoaded = async ({ state }) => {
  while (true) {
    if (state.loaded) break
    await new Promise(resolve => setTimeout(resolve, 10))
  }
}

export const createNewActiveCart = async ({ dispatch, commit, state, rootState }, { input, storeType }) => {
  // Set cart type to 'StockCart', 'ContainerCart', etc.
  input.cartType = properCase(storeType) + 'Cart'
  const result = await store.$apollo.mutate({
    mutation: gql`
      mutation createCart($input: CartInput!) {
        createCart (input: $input) { id }
      }
    `,
    variables: {
      input
    },
    context: {
      headers: {
          uuid: rootState.auth.currentUUID
      }
    }
  })
  // eslint-disable-next-line no-undef
  analytics.track(`Create ${storeType} Cart`, {
    cartId: result.data?.createCart?.id,
    name: input.name
  })
  if (storeType === 'stock') {
    await dispatch('auth/updateCurrentAccount', { activeCartId: result.data.createCart.id }, { root: true })
  } else if (storeType === 'container') {
    await dispatch('auth/updateCurrentAccount', { activeContainerCartId: result.data.createCart.id }, { root: true })
  } else if (storeType === 'retail' && !!rootState.auth.currentAccount) {   
    await dispatch('auth/updateCurrentAccount', { activeRetailCartId: result.data.createCart.id }, { root: true })
  } else if (storeType === 'retail' && !!rootState.auth.currentGuest) {
    await dispatch('auth/updateCurrentGuest', { activeRetailCartId: result.data.createCart.id }, { root: true })
  }
  return result.data?.createCart?.id
}

export const fetchActiveCart = async ({ dispatch, commit, rootState }, storeType) => {
  let activeCartId
  if (storeType === 'stock') {
    if (!rootState.auth.currentAccount) return
    activeCartId = rootState.auth.currentAccount.activeCartId
  } else if (storeType === 'container') {
    if (!rootState.auth.currentAccount) return
    activeCartId = rootState.auth.currentAccount.activeContainerCartId
  } else if (storeType === 'retail') {
    if (!rootState.auth.currentAccount){
      activeCartId = rootState.auth.currentGuest.activeRetailCartId
    }else{
      activeCartId = rootState.auth.currentAccount.activeRetailCartId
    }
  } else {
    throw Error(`Invalid cartType ${storeType}`)
  }

  if(!activeCartId){
    await dispatch('createNewActiveCart', { input: { name: `${properCase(storeType)} Cart ${moment().format('DD/MM/YY')}` }, storeType })
  }else{
    try {
      const result = await store.$apollo.query({
        query: gql`
          query fetchActiveCart ($id: ID!) {
            cart(id: $id) {
              id,
              name,
              notes,
              createdAt,
              updatedAt,
              items {
                id,
                skuId,
                qty,
                sku {
                  id,
                  attributes,
                  options,
                  price,
                  stock,
                  product {
                    id
                    attributes,
                    name,
                    images {
                      url
                      name
                    },
                    urlSlug
                  }
                }
              }
            }
          }
        `,
        variables: {
          id: activeCartId
        },
        deep: true,
        context: {
          headers: {
              uuid: rootState.auth.currentUUID
          }
        },
        fetchPolicy: 'network-only'
      })
      commit(`setActive${properCase(storeType)}Cart`, result.data.cart)
      commit(`setCart${properCase(storeType)}Qty`, result.data.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0));
    } catch (ex) {
      // Failed to fetch cart - either cart doesn't exist or cartId is null
      await dispatch('createNewActiveCart', { input: { name: `${properCase(storeType)} Cart ${moment().format('DD/MM/YY')}` }, storeType })      
      await dispatch('fetchActiveCart', storeType)
    }
  }
}
